import { HttpRequest } from './request';
import { EventEmitterFactory } from '../event/emitter.factory';

export function HttpRequestFactory(): HttpRequest {
  return new HttpRequest(new XMLHttpRequest(), EventEmitterFactory());
}
